
import { defineComponent } from 'vue'
import SubscriptionMixin from '~/mixins/subscriptionMixin'

import { StripeCardElementChangeEvent } from '@stripe/stripe-js'
import OwnerBillingMixin from '~/mixins/ownerBillingMixin'
import { UpdatePaymentActionChoice } from '~/types/types'
import StripeCardInput from '../StripeCardInput.vue'

export default defineComponent({
  name: 'UpdateCardModal',
  mixins: [SubscriptionMixin, OwnerBillingMixin],
  data() {
    return {
      cardDetails: '',
      validCardDetails: false,
      cardInputFocus: false,
      updateCardLoading: false,
      updateCardState: null as null | 'SUCCESS' | 'FAIL'
    }
  },

  methods: {
    handleStripeCardChange(event: StripeCardElementChangeEvent) {
      this.validCardDetails = event.error ? false : true
    },

    async updateCard(close: () => void): Promise<void> {
      this.updateCardLoading = true
      this.updateCardState = null

      try {
        const stripeInput = this.$refs[
          'card-modal-stripe-input'
        ] as unknown as typeof StripeCardInput
        const res = await this.$stripe?.createToken(stripeInput.cardElement)

        if (res?.token) {
          const updateRes = await this.updatePaymentSource({
            id: this.owner.id,
            token: res.token.id,
            action: UpdatePaymentActionChoice.Update
          })
          if (updateRes.ok) {
            const { owner, provider } = this.$route.params
            await this.fetchBillingDetails({
              login: owner,
              provider,
              refetch: true
            })
            this.$toast.success('We have updated the card successfully')
            this.updateCardState = 'SUCCESS'
            close()
          } else {
            throw new Error()
          }
        }
      } catch (e) {
        this.updateCardState = 'FAIL'
        this.$toast.danger(
          'Something went wrong processing your card payment. Please check your card details or contact support.'
        )
      } finally {
        this.updateCardLoading = false
      }
    }
  }
})
